import { useCallback } from "react";

import type { OptionStock_StockManagementQuery } from "@/lib/gql/__generated__/graphql";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import { useCreateOptionStockFormModel } from "./usecase/use-create-form-model";

// eslint-disable-next-line import/no-restricted-paths
import type { ApolloQueryResult } from "@apollo/client";

type Props = {
	serverModel: OptionStock_StockManagementQuery;
	onFetchOptionStock: ({
		input: { startDt, endDt },
	}: {
		input: { startDt: string; endDt: string };
	}) => Promise<ApolloQueryResult<OptionStock_StockManagementQuery | undefined>>;
};

export const useInitialized = ({ serverModel, onFetchOptionStock }: Props) => {
	const { isDirty, isValid, optionStockDiffStore, onReInitialize, onUpdateOptionStock } =
		useCreateOptionStockFormModel({ serverModel });

	const onRefetch = useCallback(
		async (input: { startDt: string; endDt: string }) => {
			const { data: serverModel, error, errors } = await onFetchOptionStock({ input });

			if (error || errors) {
				notifyUserEventInfo({
					variant: "error",
					title: "オプション在庫の取得に失敗しました",
					description: "時間を置いて再度お試しください",
				});
				return;
			} else if (serverModel) {
				onReInitialize();
			}
		},
		[onFetchOptionStock, onReInitialize],
	);

	return {
		serverModel,
		isDirty,
		isValid,
		optionStockDiffStore,
		onUpdateOptionStock,
		onRefetch,
	};
};
